import { bootstrapApplication } from '@angular/platform-browser';
import { MarautoAppConfig } from './app/mareautoAppConfig';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, MarautoAppConfig).catch((err) => console.error(err));
